var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCasual = function SvgCasual(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M32 15a4 4 0 1 1-8 0 4 4 0 0 1 8 0m-3 5.917A6.002 6.002 0 0 0 28 9a6 6 0 0 0-1 11.917v7.663c-2.637.435-4.03 2.572-4.325 4.42H21v-3a2 2 0 0 0-2-2h-3a2 2 0 0 0-2 2v3h-1a4 4 0 0 0-4 4v6a4 4 0 0 0 4 4h30a4 4 0 0 0 4-4v-6a4 4 0 0 0-4-4h-9.45c-.333-1.887-1.913-3.99-4.55-4.42zM16 33h3v-3h-3zm-2 2h-1a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h30a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2H14m17.5-2h-6.79c.308-1.214 1.372-2.5 3.29-2.5 1.96 0 3.142 1.318 3.5 2.5",
    className: "casual_svg__fill",
    clipRule: "evenodd"
  })));
};
export default SvgCasual;